import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { selectAppName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface VirtualCardCapTooltipProps {
  openLeft: boolean
}

const VirtualCardCapTooltip: React.FC<VirtualCardCapTooltipProps> = (
  props,
): React.ReactElement => {
  const appName = useSelector(selectAppName)
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            '${virtualCardCap} is the max number of virtual cards cards this user can create per registered credit card ("Account"). This cap is controlled by ${appName}, and can be manually updated by ${appName} upon request (on a case-by-case basis).'
          }
          expressions={{
            virtualCardCap: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Virtual card cap'} />
              </span>
            ),
            appName: appName,
          }}
        />
      </p>
    </Tooltip>
  )
}

export default VirtualCardCapTooltip
